<template src="./html/Operations.html"></template>

<script>
	import Index from './../views/Index.vue'
	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		components: {
			'index': Index,
		},
		mounted() {
			this.init()
		},
		data () {
			return {
				disabled: true,
			}
		},
		methods: {
			init() {
				this.checkFieldType()
			},
			checkFieldType() {
				var disabled = true
				if(this.data) {
					if(this.data.product_attribute_type_field_id != 3 || this.data.product_attribute_type_field_id != 4) {
						disabled = false
					}
				}
				this.disabled = disabled
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/operations/layout/Operations.vue